import { parse } from "date-fns";

const newDate = (dateStr) =>
  /* 2020-07-08 14:30 */ parse(dateStr, "yyyy-MM-dd HH:mm", new Date());

export default newDate;
